import SiteHeader from './components/site-header';
import QuickNav from './components/quick-nav';
import BannerVideo from './components/banner-video';
import Modal from './components/modal';
import ModalPopup from './components/modal-popup';
import Accordion from './components/accordion';
import LocationsMap from './components/locations-map';

import PostsListBlog from './components/posts-list/posts-list-blog';
import PostsListSearch from './components/posts-list/posts-list-search';

import { processExternalLinks } from './util/general-util';
import ScrollWatcher from './util/scroll-watcher';
import { createSingleUseObserver } from './util/intersection-observer';
import { initHelloBar } from './util/hello-bar';
import { showVideoModal } from './util/modal-helpers';

import GatedContent from './components/blocks/form';
import GatedPost from './components/posts-list/gated-posts.js';
import BlockSlider from './components/blocks/slider';
import BlockHistory from './components/blocks/history';
import BlockImageCarousel from './components/blocks/image-carousel';
import BlockGrid from './components/blocks/grid';
import BlockProduct from './components/blocks/product';

class App {
	constructor() {
		this.instances = {
			components: {
				quickNav: null,
				siteHeader: null,
				bannerVideo: null,
				postsListBlog: [],
				postsListSearch: [],
				accordion: [],
				modalPopup: [],
				locationsMap: []
			},
			templates: {},
			blocks: {},
			scrollWatcher: null,
		};

		this.init();
		this.initComponents();
		this.initTemplates();
		this.initBlocks();
		this.initSocialShare();
	}

	init() {
		processExternalLinks({
			target: '_blank',
			rel: 'noopener'
		});

		Modal.setDefaults({
			closeDuration: 400,
			closeButtonContent: `
				<svg xmlns="http://www.w3.org/2000/svg" class="modal__close-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
					<line x1="18" y1="6" x2="6" y2="18"></line>
					<line x1="6" y1="6" x2="18" y2="18"></line>
				</svg>
			`.trim()
		});

		this.scrollWatcher = new ScrollWatcher((params) => {
			ScrollWatcher.defaultCallback(params, 100);
		});

		initHelloBar((hbEl) => {
			document.body.style.marginTop = `${hbEl.offsetHeight}px`;

			const siteHeaderEl = document.querySelector('.site-header');

			if (siteHeaderEl) {
				siteHeaderEl.style.marginTop = `${hbEl.offsetHeight}px`;
			}
		});
	}

	async initComponents() {
		// site header
		const siteHeaderEl = document.querySelector('.site-header');


		if (siteHeaderEl) {
			this.instances.components.siteHeader = new SiteHeader(siteHeaderEl);
		}

		// quick nav
		const quickNav = document.querySelector('.quick-nav');

		if (quickNav) {
			this.instances.components.quickNav = new QuickNav(quickNav);
		}

		// banner cover video
		const bannerCoverVideoEl = document.querySelector('.banner__cover-video');

		if (bannerCoverVideoEl) {
			this.instances.components.bannerVideo = new BannerVideo(bannerCoverVideoEl);
		}

		// posts list - blog
		Array.from(document.querySelectorAll('.posts-list--blog')).forEach((postsListBlogEl) => {
			this.instances.components.postsListBlog.push(new PostsListBlog(postsListBlogEl));
		});

		// posts list - search
		Array.from(document.querySelectorAll('.posts-list--search')).forEach(
			(postsListSearchEl) => {
				this.instances.components.postsListSearch.push(
					new PostsListSearch(postsListSearchEl)
				);
			}
		);

		// accordion
		Array.from(document.querySelectorAll('.accordion-container')).forEach((accordionEl) => {
			this.instances.components.accordion.push(new Accordion(accordionEl));
		});

		// Gated forms
		Array.from(document.querySelectorAll('.block-form')).forEach((blockEl) => {
			this.instances.components.gatedForm = new GatedContent(blockEl);
		});

		// locations map
		Array.from(document.querySelectorAll('#locations-map')).forEach(
			(mapEl) => {
				this.instances.components.locationsMap.push(
					new LocationsMap(mapEl)
				);
			}
		);

		Array.from(document.querySelectorAll('.main-content')).forEach((postContent) => {
			this.instances.components.gatedPost = new GatedPost(postContent); 
		});
	}

	initTemplates() {
		// TODO: initialize templates here
	}

	async initBlocks() {
		// TODO: initialize blocks here
		// Block: Slider
		const blockSliderElements = document.querySelectorAll('.block-slider');

		blockSliderElements.forEach((blockSliderEl) => {
			this.instances.components.blockSlider = new BlockSlider(blockSliderEl);
		});

		// Block: Grid
		const blockGridElements = document.querySelectorAll('.block-grid');

		blockGridElements.forEach((blockGridEl) => {
			this.instances.components.blockGrid = new BlockGrid(blockGridEl);
		});

    	// video modal
		Array.from(document.querySelectorAll('.js__modal--video')).forEach(
			(modalPopupEl) => {
				this.instances.components.modalPopup.push(new ModalPopup(modalPopupEl));
			} 
		);

		// Block: Image Carousel
		const blockImageCarouselElements = document.querySelectorAll('.block-image-carousel');

		blockImageCarouselElements.forEach((blockImageCarouselEl) => {
			this.instances.components.blockImageCarousel = new BlockImageCarousel(blockImageCarouselEl);
		});

		// Block: Product
		const blockProductElements = document.querySelectorAll('.block-product');

		blockProductElements.forEach((blockProductEl) => {
			this.instances.components.blockProduct = new BlockProduct(blockProductEl);
		});

		// Block: History
		const blockHistoryElements = document.querySelectorAll('.block-history');

		blockHistoryElements.forEach((blockHistoryEl) => {
			this.instances.components.blockHistory = new BlockHistory(blockHistoryEl);
		});

		// setup block animation watchers
		const animateBlocks = document.querySelectorAll('.block-animate');

		if (animateBlocks && animateBlocks.length) {
			try {
				animateBlocks.forEach((watchEl) =>
					createSingleUseObserver(watchEl, (entry, el) => {
						el.classList.remove('block-animate');
					})
				);
			} catch (err) {
				console.error(err);
			}
		}
	}

	initSocialShare() {
		const socialShareEls = document.querySelectorAll('[data-social-share]');

		Array.from(socialShareEls).forEach((el) => {
			el.addEventListener('click', (e) => {
				const site = el.getAttribute('data-social-share');
				const shareUrl = el.getAttribute('href');

				e.preventDefault();

				if (!shareUrl) {
					return;
				}

				window.open(shareUrl, `${site}Share`, 'width=626,height=436');
			});
		});
	}
}

export default App;
